import queryString from 'query-string'

export const AUTH_RETURN_URL_QUERY_KEY = 'returnUrl'

export const getSafeReturnUrl = (): string => {
  const currentPath = `${window.location.pathname}${window.location.search}${window.location.hash}`

  if (currentPath.startsWith('/auth')) {
    return '/'
  }

  return currentPath || '/'
}

export const getAuthRedirectUrl = (): string => {
  return `/auth?${queryString.stringify({
    [AUTH_RETURN_URL_QUERY_KEY]: getSafeReturnUrl()
  })}`
}

export const getValidatedReturnUrl = (search: string): string => {
  const parsedSearch = queryString.parse(search)
  const returnUrl = parsedSearch[AUTH_RETURN_URL_QUERY_KEY]

  if (
    typeof returnUrl === 'string' &&
    returnUrl.startsWith('/') &&
    !returnUrl.startsWith('/auth')
  ) {
    return returnUrl
  }

  return '/'
}

export const redirectToAuth = (): void => {
  const authUrl = getAuthRedirectUrl()

  if (`${window.location.pathname}${window.location.search}` !== authUrl) {
    window.location.assign(authUrl)
  }
}
